




















import {Component, Vue, Prop} from 'vue-property-decorator';
import { DATE_TYPE } from '@/const/types';

@Component<FormDateTimeRangePicker>({
    name: 'FormDateTimeRangePicker',
})
export default class FormDateTimeRangePicker extends Vue{
    @Prop({type: Array, default: ['', '']}) value!: DATE_TYPE[];
    @Prop({type: Object, required: true}) terms!: any;

    get model() {
        return this.value;
    }
    set model(v) {
        this.$emit('input', v);
    }
    private addDateHandler(toAdd: number, isMonth: boolean = false) {
        const end = new Date();
        const start = new Date();
        end.setTime( end.getTime() - end.getTime() % (1000 * 60 * 60 * 24) + (1000 * 60 * 60 * (24-9)) - 1000)
        start.setTime(start.getTime() - start.getTime() % (1000 * 60 * 60 * 24) - (1000 * 60 * 60 * 9))
        const model = this.model as any;
        if (toAdd !== 0) {
            if (model) {
                if (model[0] && model[0] !== '') start.setTime((model[0] as Date).getTime());
                if (model[1] && model[1] !== '') end.setTime((model[1] as Date).getTime());
            }
            if (isMonth) {
                end.setMonth(end.getMonth() + toAdd);
            } else {
                end.setDate(end.getDate() + toAdd);
            }
        }
        this.$emit('input', [start, toAdd === -1 ? '' : end]);
    }
}
